import { CSVLink } from 'react-csv';
import { IconCSV } from '../../assets/icons';

const CSVDownloadButton = ({ data, filename, className, children }) => {

    return (
        <div>
            <CSVLink
                data={data}
                filename={filename}
                className={className}
                style={{display: "inline-block", border: "1px solid #d1d5db", padding: "5px 10px", borderRadius: "5px", textDecoration: "none", color: "#000", backgroundColor: "rgba(255,255,255,.5)"}}
            >
                <IconCSV style={{width: "24px", height: "24px"}} />
                
                {children && (
                    <div style={{fontSize: ".8rem"}}>
                        {children}
                    </div>
                )}
            </CSVLink>
        </div>
    );
};

export default CSVDownloadButton;